import {Exclude, Expose, instanceToPlain, plainToInstance, Transform, Type} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {Default} from "../util/decorators";
import {
    VolumeInventorySnapshotEntryArrayValidator,
    VolumeInventorySnapshotEntryEntity
} from "./volume-inventory-snapshot-entry";
import {TimeGroup, toTimeGroup} from "./time-group";

export const VolumeInventorySnapshotValidator = t.intersection([
    t.type({
        objectId: t.string,
        cargoSubtype: t.string,
        objectType: t.string,
        timeGroup: t.string,
        regionId: t.string,
    }),
    t.partial({
        objectName: t.string,
        volumeUnitOfMeasure: t.string,
        entries: VolumeInventorySnapshotEntryArrayValidator,
    }),
]);

export const VolumeInventorySnapshotArrayValidator = t.array(VolumeInventorySnapshotValidator);

export type VolumeInventorySnapshot = t.TypeOf<typeof VolumeInventorySnapshotValidator>;
export type VolumeInventorySnapshotArray = t.TypeOf<typeof VolumeInventorySnapshotArrayValidator>;

@Exclude()
export class VolumeInventorySnapshotEntity {
    @Expose()
    objectId!: string;

    @Expose()
    objectName?: string;

    @Expose()
    objectType!: string;

    @Expose()
    regionId!: string;

    @Expose()
    @Transform(getDatabaseCodeTransformer(toCargoSubtype))
    cargoSubtype!: CargoSubtype

    @Expose()
    volumeUnitOfMeasure?: string;

    @Expose()
    @Transform(getDatabaseCodeTransformer(toTimeGroup))
    timeGroup!: TimeGroup

    @Expose()
    @Type(() => VolumeInventorySnapshotEntryEntity)
    @Default([])
    entries: VolumeInventorySnapshotEntryEntity[] = [];

    /**
     * Constructor for VolumeInventorySnapshotEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(containerVolumeInventoryGroup: VolumeInventorySnapshot): VolumeInventorySnapshotEntity {
        return plainToInstance(
            VolumeInventorySnapshotEntity,
            containerVolumeInventoryGroup,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    loadTypeValue(): Promise<VolumeInventorySnapshot> {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSON(VolumeInventorySnapshotValidator, object);
    }

    asTypeValue(): VolumeInventorySnapshot {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSONNow(VolumeInventorySnapshotValidator, object);
    }
}
